import mainAPI from "../api/MainAPI";
import utils from "../utils/utils";
import toasts from "../utils/toasts";

class GeneralChecksModel {
	constructor() {
		this.checks = [];
		this.categories = {};
		this.callbacks = [];
		this.lastSubId = 1;
	}

	initialize = async (general_check_id) => {
		this.checks = await mainAPI.general_check.questions(general_check_id);
		this.submission = await mainAPI.general_check_submission.create({general_check_id});
		this.updateCategories();
		this.fireChange();
	}

	categoriesArray = () => {
		const categories = [];
		for (let i in this.categories) {
			categories.push(this.categories[i]);
		}
		return categories;
	}
	getCategory = (categoryId) => {
		return this.categories[categoryId];
	}
	updateCategories = () => {
		this.categories = {};

		// Group checks by category
		for (const [id, check] of Object.entries(this.checks)) {
			const category = check.general_check_category_id;

			if (!this.categories[category]) {
				this.categories[category] = {
					id: check.general_check_category_id,
					name: check.general_check_category_name,
					total: 0,
					completed: 0,
					passed: 0,
					failed: 0,
					items: []
				};
			}

			this.categories[category].total++;
			this.categories[category].items.push(id);

			if (check.completed) {
				this.categories[category].completed++;
				if (check.passed) {
					this.categories[category].passed++;
				} else {
					this.categories[category].failed++;
				}
			}
		}
	}

	// Get all checks
	getAllChecks = () => {
		return this.checks;
	}

	// Get a specific check by ID
	getCheck = (questionId) => {
		return this.checks.find(check => check.general_check_question_id === questionId);
	}
	getChecksInCategory = (categoryId) => {
		const checks = [];
		for (let i in this.checks) {
			if (this.checks[i].general_check_category_id === categoryId) {
				checks.push(this.checks[i]);
			}
		}
		return checks;
	}

	// Update a single check
	updateCheck = async (questionId, data) => {
		const checkIndex = this.checks.findIndex(check => check.general_check_question_id === questionId);
		this.checks[checkIndex] = {
			...this.checks[checkIndex],
			...data
		};
		const check = this.checks.find(check => check.general_check_question_id === questionId);
		if (check.id) {
			await mainAPI.general_check_response.update({...check, report_to_admin: !!check.report_to_admin});
		} else {
			const response = await mainAPI.general_check_response.create({
				...check,
				general_check_submission_id: this.submission.id
			})
			this.checks[checkIndex] = {
				...this.checks[checkIndex],
				...data,
				id: response.id
			};
		}

		this.updateCategories();
		this.fireChange();
		return this.getCheck(questionId);
	}
	onChange = (callback) => {
		this.lastSubId++;
		this.callbacks[this.lastSubId] = callback;
		return this.lastSubId;
	};
	unsubscribe = (id) => {
		delete this.callbacks[id];
	}
	fireChange = () => {
		for (let i in this.callbacks) {
			this.callbacks[i]();
		}
	};

	// Save all checks to the server
	saveChecks = async () => {
		try {
			// Assuming mainAPI is available globally or imported
			const response = await mainAPI.saveGeneralChecks(this.checks);
			return response;
		} catch (error) {
			console.error('Error saving vehicle checks:', error);
			throw error;
		}
	}

	categoryProgress = (categoryId) => {
		let total = 0;
		for (const i in this.checks) {
			const check = this.checks[i];
			if (check.general_check_category_id !== categoryId) continue;
			if (!check.id || !check.completed) continue;
			total++;
		}
		return total;
	};
	submit = async () => {
		const res = await mainAPI.general_check_submission.update({
			id: this.submission.id,
			submitted_on: utils.client_to_server_date(new Date())
		})
		if (res) {
			toasts.show('Vehicle Check Recorded')
		} else {
			toasts.show('Something went wrong!')
		}
	};

	categoryTotal = (categoryId) => {
		let total = 0;
		for (const i in this.checks) {
			const check = this.checks[i];
			if (check.general_check_category_id !== categoryId) continue;
			total++;
		}
		return total;
	};
}

// Create a singleton instance
const generalChecksModel = new GeneralChecksModel();

export default generalChecksModel;